export default "<div class=\"row\">\n    <h1>404</h1>\n    <hr>\n    <h2>Page Not Found</h2>\n    <p>Do you even internet?</p>\n</div>\n";